export default __webpack_public_path__ + "static/media/fMaltoBuza4.576b344f.png";